import { createSlice } from '@reduxjs/toolkit'
import * as dom from "../../models/domain";
import { Chat } from "../../../store/models/domain/chat"
import { getContactsThunk } from '../../actions/domain/chat';

const initialState: dom.ChatState = {
  record: {
    contacts: [],
    activeChatIds: [],
  },
  loading: 'idle',
  isInitialized: false,
  error: null
}

export type ChatState = {
  chat: Chat
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    initChatState(state) {
      state.isInitialized = true;
    },
    addActiveChat(state, action) {
      const chatId = action.payload;
      if (state.record.activeChatIds.includes(chatId)) return; // avoid duplicates on repeat clicks
      state.record.activeChatIds.push(chatId);
    },
    removeActiveChat(state, action) {
      const chatId = action.payload;
      state.record.activeChatIds = state.record.activeChatIds.filter(
          (id) => id !== chatId
      );
    },
    clearActiveChats(state) {
      state.record.activeChatIds = [];
    },
  },
  extraReducers: builder => {

    // get chat contacts
    builder.addCase(getContactsThunk.fulfilled, (state, action) => {
      state.record.contacts = action.payload;
      state.loading = 'succeeded';
      state.error = null;
    })
    builder.addCase(getContactsThunk.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error;
    })
  }
})

export const { initChatState, addActiveChat, removeActiveChat, clearActiveChats } = chatSlice.actions;

export default chatSlice.reducer